import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiCheck, FiChevronUp } from "react-icons/fi";
import Header from "../component/header/2SN";
import Footer from "../component/footer/2SN_Footer";


class ReactJS extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='ReactJS || 2SN Healthcare ltd' pageUrl='/react-JS' metaTitle="React" metaImage="/assets/images/bg/bg-image-25.jpg"
                    metaDescription="Elevate your web development with React. 2SN Healthcare ltd' team of skilled developers specializes in building complex applications that require fast and efficient data processing, scalability, and high performance." />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--25" data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">ReactJS</h2>
                                    <p>Your perfect companion, if you want to build a complex application that needs faster and voluminous data processing with scalability.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper  */}
                <main className="page-wrapper">

                    {/* Start Columns Area  */}
                    <div className="rn-columns-area ptb--120 bg_color--5">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="single-column">
                                        {/* <h4 className="tilte">One Full</h4> */}
                                        <p>ReactJS is a JavaScript library that specializes in building interactive user interfaces and web applications quickly and efficiently with significantly less code than you would require with vanilla JavaScript.</p>
                                        <p>React JS has gained stability and popularity due to its ability to create fast, efficient, and scalable web applications. 2SN Healthcare ltd delivers full cycle services, from business analysis and requirement management to continuous support and maintenance of the deployed software.</p>
                                        <p>ReactJS provides a high amount of corporate investment that sets it apart from its peers. Though it's a front-end technology, ReactJS can be paired with many other technologies executing the back-end, too. This makes React serve as a vibrant ecosystem of tools and approaches, which conditions its having so many different use cases – web app development, mobile app development, static site building, desktop apps development, and even VR app development.</p>
                                        <p>Our development capabilities allow our clients to safely trust 2SN Healthcare ltd with their most complex and ambitious ReactJS projects.</p>
                                        <h4 className="title">Why Choose ReactJS?</h4>
                                        <ul className="list-style--1">
                                            <li><FiCheck />React JS is very flexible.</li>
                                            <li><FiCheck />Offers fast rendering.</li>
                                            <li><FiCheck />Helps to build easily testable rich user 2interfaces.</li>
                                            <li><FiCheck />ReactJS can be SEO-friendly.</li>
                                            <li><FiCheck />Strong community support.</li>


                                        </ul>
                                        <h4 className="title">Our ReactJS Services</h4>

                                        <ul className="list-style--1">
                                            <li><FiCheck />Custom ReactJS Web Development</li>
                                            <li><FiCheck />Interactive UI Development</li>
                                            <li><FiCheck />App Migration to React</li>
                                            <li><FiCheck />Enterprise Web Development</li>
                                            <li><FiCheck />Maintenance and Support</li>

                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Start Columns Area  */}






                </main>
                {/* End Page Wrapper  */}


                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default ReactJS;